/** `displayName` das partes que o Root encaixa nos estados e nas colunas da tabela. */
export const COLUMN_PART = "HubTable.Column";
export const EMPTY_PART = "HubTable.Empty";
export const LOADING_PART = "HubTable.Loading";
export const ERROR_PART = "HubTable.Error";
export const FORBIDDEN_PART = "HubTable.Forbidden";
